var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailSend = function SvgMailSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M40 8H12c-2.206 0-4 1.794-4 4v10h4v-6l12.8 9.6a2 2 0 0 0 2.4 0L40 16v18H24v4h16c2.206 0 4-1.794 4-4V12c0-2.206-1.794-4-4-4M26 21.5 13.332 12h25.336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M4 24h14v4H4zm4 6h12v4H8zm6 6h8v4h-8z"
  })));
};
export { SvgMailSend as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQwIDhIMTJDOS43OTQgOCA4IDkuNzk0IDggMTJWMjJIMTJWMTZMMjQuOCAyNS42QzI1LjE0NjMgMjUuODU5MyAyNS41NjczIDI1Ljk5OTUgMjYgMjUuOTk5NUMyNi40MzI3IDI1Ljk5OTUgMjYuODUzNyAyNS44NTkzIDI3LjIgMjUuNkw0MCAxNlYzNEgyNFYzOEg0MEM0Mi4yMDYgMzggNDQgMzYuMjA2IDQ0IDM0VjEyQzQ0IDkuNzk0IDQyLjIwNiA4IDQwIDhaTTI2IDIxLjVMMTMuMzMyIDEySDM4LjY2OEwyNiAyMS41WiIgZmlsbD0iIzkwOUE5RiIvPgo8cGF0aCBkPSJNNCAyNEgxOFYyOEg0VjI0Wk04IDMwSDIwVjM0SDhWMzBaTTE0IDM2SDIyVjQwSDE0VjM2WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";